export default class ShadowHighlightsRecovery {
	constructor() {
		this.shadowsRecovery = {
			minValue: -100,
			maxValue: 100,
			calcValue: 100,
		};

		this.highlightsRecovery = {
			minValue: -100,
			maxValue: 100,
			calcValue: 100,
		};

		this.opacity = {
			minValue: 0,
			maxValue: 100,
		};

		this.curveNames = ["ShadowRecovery", "HiglightRecovery"];
	}

	addBlock(blockNum = lutify.blocks.length) {
		UI.createAdjustmentBlockTemplate("shadow-highlights-recovery", blockNum);
		var element = UI.getAdjustmentBlock(blockNum);

		$(element)
			.find(".expand_options")
			.trigger("click", [false]);

		$(element)
			.find(".shadows_rec_slider")
			.on("input", _ => this.sRecoveryHandler($(element)));
		$(element)
			.find(".shadows_rec_range")
			.on("change", _ => this.sRecoveryValueHanlder($(element)));

		$(element)
			.find(".highlights_rec_slider")
			.on("input", _ => this.hRecoveryHandler($(element)));
		$(element)
			.find(".highlights_rec_range")
			.on("change", _ => this.hRecoveryValueHandler($(element)));

		$(element).find(".opacity_slider").on("input", () => this.opacitySliderHandler($(element)));
		$(element).find(".opacity-input").on("change", () => this.opacityInputHandler($(element)));

		UI.initKnob(element, {
			size: 30,
		});

		blocks.add({
			name: "shadowHighlightsRecovery",
			passes: this.addPasses(),
			blockNum,
			blendingMode: 0,
			blendingModeName: "Normal",
			opacity: 100,
			curves: [],
			values: {
				shadowsRecovery: 0,
				highlightsRecovery: 0,
			},
		});

		blocks.createCurves(this.curveNames, blockNum);
	}

	addPasses() {
		let shaderPass_shadows = gpu.createCurveShaderPass("shadows revovery");
		let shaderPass_highlights = gpu.createCurveShaderPass("highlights recovery");

		gpu.addPassToComposer(shaderPass_shadows, "toMiddle");
		gpu.addPassToComposer(shaderPass_highlights, "toMiddle");
		return [shaderPass_shadows, shaderPass_highlights];
	}

	sRecoveryHandler($el) {
		blocks.checkSwitchHandler($el);
		lutify.getActiveBlock().passes[0].enabled = true;

		var shadowValue = UI.getAdjustmentBlock_sliderValue($el);
		UI.setAdjustmentBlock_rangeValue($el, shadowValue);

		let block = lutify.getActiveBlock();
		block.values.shadowsRecovery = shadowValue / this.shadowsRecovery.calcValue;
		this.curveShadowRecovery(block.values.shadowsRecovery);
	}

	sRecoveryValueHanlder($el) {
		blocks.checkSwitchHandler($el);
		lutify.getActiveBlock().passes[0].enabled = true;

		var shadowValue = UI.getAdjustmentBlock_rangeValue($el);

		if (shadowValue > this.shadowsRecovery.maxValue) {
			shadowValue = this.shadowsRecovery.maxValue;
			UI.setAdjustmentBlock_rangeValue($el, shadowValue);
		}

		if (shadowValue < this.shadowsRecovery.minValue) {
			shadowValue = this.shadowsRecovery.minValue;
			UI.setAdjustmentBlock_rangeValue($el, shadowValue);
		}

		UI.setAdjustmentBlock_sliderValue($el, shadowValue);
		lutify.getActiveBlock().values.shadowsRecovery = shadowValue / this.shadowsRecovery.calcValue;
		this.curveShadowRecovery(lutify.getActiveBlock().values.shadowsRecovery);
	}

	hRecoveryHandler($el) {
		blocks.checkSwitchHandler($el);
		lutify.getActiveBlock().passes[1].enabled = true;

		var highlightsValue = UI.getAdjustmentBlock_sliderValue($el, 1);
		UI.setAdjustmentBlock_rangeValue($el, highlightsValue, 1);

		let block = lutify.getActiveBlock();
		block.values.highlightsRecovery = highlightsValue / this.highlightsRecovery.calcValue;
		this.curveHighlightsRecovery(block.values.highlightsRecovery);
	}

	hRecoveryValueHandler($el) {
		blocks.checkSwitchHandler($el);
		lutify.getActiveBlock().passes[1].enabled = true;

		var highlightsValue = UI.getAdjustmentBlock_rangeValue($el, 1);

		if (highlightsValue > this.highlightsRecovery.maxValue) {
			highlightsValue = this.highlightsRecovery.maxValue;
			UI.setAdjustmentBlock_rangeValue($el, highlightsValue, 1);
		}

		if (highlightsValue < this.highlightsRecovery.minValue) {
			highlightsValue = this.highlightsRecovery.minValue;
			UI.setAdjustmentBlock_rangeValue($el, highlightsValue, 1);
		}

		UI.setAdjustmentBlock_sliderValue($el, highlightsValue, 1);
		lutify.getActiveBlock().values.highlightsRecovery = highlightsValue / this.highlightsRecovery.calcValue;
		this.curveHighlightsRecovery(lutify.getActiveBlock().values.highlightsRecovery);
	}

	curveShadowRecovery(sVal) {
		let curve = lutify.getActiveBlock().curves[0].colorCurve;
		curve.points = [];

		curve.points.push({ x: 0, y: 0 });
		curve.points.push({ x: 0.1 - 0.05 * sVal, y: 0.1 + 0.05 * sVal });
		curve.points.push({ x: 0.2 - 0.07 * sVal, y: 0.2 + 0.07 * sVal });
		curve.points.push({ x: 0.35 - 0.05 * sVal, y: 0.35 + 0.05 * sVal });
		curve.points.push({ x: 0.5, y: 0.5 + 0.032 * sVal });
		curve.points.push({ x: 0.65625, y: 0.65625 });
		curve.points.push({ x: 0.75, y: 0.75 });
		curve.points.push({ x: 1, y: 1 });

		curve.draw();
		curve.updateValues();
		this.callGPUSRecovery(curve.rgb);
	}

	curveHighlightsRecovery(hVal) {
		let curve = lutify.getActiveBlock().curves[1].colorCurve;
		curve.points = [];

		curve.points.push({ x: 0, y: 0 });
		curve.points.push({ x: 0.25, y: 0.25 });
		curve.points.push({ x: 0.34375, y: 0.34375 });
		curve.points.push({ x: 0.5, y: 0.5 - 0.032 * hVal });
		curve.points.push({ x: 0.65 + 0.05 * hVal, y: 0.65 - 0.05 * hVal });
		curve.points.push({ x: 0.8 + 0.07 * hVal, y: 0.8 - 0.07 * hVal });
		curve.points.push({ x: 0.9 + 0.05 * hVal, y: 0.9 - 0.078 * hVal });
		curve.points.push({ x: 1, y: 1 - 0.0781 * hVal });

		curve.draw();
		curve.updateValues();
		this.callGPUHRecovery(curve.rgb);
	}

	callGPUSRecovery(points) {
		let curveTexture = gpu.pointsToCurve(points);
		lutify.getActiveBlock().passes[0].uniforms["map"].value = curveTexture;
		gpu.render();
	}

	callGPUHRecovery(points) {
		let curveTexture = gpu.pointsToCurve(points);
		lutify.getActiveBlock().passes[1].uniforms["map"].value = curveTexture;
		gpu.render();
	}

	opacitySliderHandler($element) {
		let opacityValue = $element.find(".opacity_slider").val();
		let calcOpacityValue = opacityValue * 0.01;

		$element.find(".opacity-input").val(opacityValue);

		lutify.getActiveBlock().opacity = opacityValue;
		lutify.getActiveBlock().passes.forEach(pass => {
			pass.uniforms.opacity.value = calcOpacityValue;
		})

		gpu.render();
	}

	opacityInputHandler($element) {
		let opacityValue = $element.find(".opacity-input").val();
		let opacitySlider = $element.find(".opacity_slider");

		if (opacityValue > this.opacity.maxValue) opacityValue = this.opacity.maxValue;
		if (opacityValue < this.opacity.minValue) opacityValue = this.opacity.minValue;

		opacitySlider.val(opacityValue);
		opacitySlider.trigger("input");
	}

	applyChanges($block, values, blockData) {
		let shadowsRecovery = values.shadowsRecovery * this.shadowsRecovery.calcValue;
		let highlightsRecovery = values.highlightsRecovery * this.highlightsRecovery.calcValue;
		UI.setAdjustmentBlock_rangeValue($block, shadowsRecovery);
		UI.setAdjustmentBlock_rangeValue($block, highlightsRecovery, 1);
		$block.find(".shadows_rec_range").trigger("change");
		$block.find(".highlights_rec_range").trigger("change");

		if ('opacity' in blockData) {
			$block.find(".opacity-input").val(parseInt(blockData.opacity));
			$block.find(".opacity-input").trigger("change");
		}
	}
}
